import React from 'react'
import { Link } from 'react-router-dom'
import routes from '../../../config/routes'

const TempListRoutesContainer = () => {
  return (
    <div>
      <h1>Lista de telas</h1>

      <ul>
        {Object.values(routes).map((item) => (
          <li key={Math.random()}>
            <Link to={item.path}>{item.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default TempListRoutesContainer
